/* eslint-disable camelcase */
import * as React from 'react';
import { Formik, FormikErrors, FormikProps } from 'formik';
import { useIntl } from 'react-intl';
import { TInputType } from '../../Forms/Fields/Input';
import LoginInput from '../../Forms/Fields/LoginInput';
import FormikValidatorService, { IInput } from '../../../Services/FormikValidatorService';
import FormikService from '../../../Services/FormikService';
import ModalForm from './ModalForm';
import ResetPasswordService from '../ResetPasswordService';

const RESPONSE_OK = 'ok';
const RESPONSE_ERROR = 'error';

interface IFormProps {
  data: any;
  token: string | null;
}

function Form(props: IFormProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const { data, token } = props;
  const [isButtonLoaderActive, setIsButtonLoaderActive] = React.useState<boolean>(false);
  const [isDone, setIsDone] = React.useState<boolean>(false);
  const [alert, setAlert] = React.useState<any>(null);

  // fields data
  const password = data.filter((i: any) => i.indexId === 'password')[0];
  const confirm_password = data.filter((i: any) => i.indexId === 'confirm_password')[0];

  // fields
  const fields: IInput[] = [
    {
      indexId: 'password',
      title: f({ id: 'resetPassword.form.newPassword' }),
      type: 'password',
      readonly: false,
      disabled: false,
      value: '',
      placeholder: '',
      rules: password && password.rules ? password.rules : [],
    },
    {
      indexId: 'confirm_password',
      title: f({ id: 'resetPassword.form.confirmPassword' }),
      type: 'password',
      readonly: false,
      value: '',
      placeholder: '',
      disabled: false,
      rules: confirm_password && confirm_password.rules ? confirm_password.rules : [],
    },
  ];

  // validation
  const handleValidate = (values: any): FormikErrors<any> => {
    return FormikValidatorService.validate(values, fields);
  };

  // save
  const save = async (values: any) => {
    if (token) {
      setIsButtonLoaderActive(true);

      const response = await ResetPasswordService.submitForm(
        token,
        values.password,
        values.confirm_password
      );

      if (response && response.status === RESPONSE_OK) {
        setIsDone(true);
      } else if (response && response.status === RESPONSE_ERROR) {
        setAlert({
          title:
            response.form &&
            response.form.validation &&
            response.form.validation.errors &&
            response.form.validation.errors.password
              ? response.form.validation.errors.password[0]
              : response.toast.message,
          message:
            response.form &&
            response.form.validation &&
            response.form.validation.errors &&
            response.form.validation.errors.password
              ? response.form.validation.errors.password[0]
              : response.toast.message,
          type: 'error',
        });
      }
      setIsButtonLoaderActive(false);
    }
  };

  // initial values
  const initialValues = FormikService.setInitialValues(fields);

  // form
  return (
    <Formik initialValues={initialValues} validate={handleValidate} onSubmit={save}>
      {(formikProps: FormikProps<any>) => (
        <ModalForm
          id="passwordreset-formik-form"
          {...formikProps}
          save={save}
          isButtonLoaderActive={isButtonLoaderActive}
          isDone={isDone}
          alert={alert}
        >
          <LoginInput
            label={fields[0].title}
            id={fields[0].indexId}
            name={fields[0].indexId}
            type={fields[0].type as TInputType}
            placeholder={fields[0].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[0].rules)}
          />
          <LoginInput
            label={fields[1].title}
            id={fields[1].indexId}
            name={fields[1].indexId}
            type={fields[1].type as TInputType}
            placeholder={fields[1].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[1].rules)}
          />
        </ModalForm>
      )}
    </Formik>
  );
}

export default Form;
